import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants';
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg';

interface ReliabilityWebAppStepsProps {
    webAppData: any
}

const ReliabilityWebAppSteps: FC<ReliabilityWebAppStepsProps> = ({ webAppData }) => {
    // Animation variants for each step
    const stepAnimation = {
        hidden: { opacity: 0, y: 30 },
        visible: (i: number) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.6,
                ease: "easeOut"
            }
        })
    };

    // Helper function to get the appropriate class based on color
    const getColorClass = (type: string, color: string) => {
        if (type === 'bg') {
            switch (color) {
                case 'yellow': return 'group-hover:bg-yellow';
                case 'green': return 'group-hover:orange-bg';
                case 'purple': return 'group-hover:bg-purple';
                default: return 'group-hover:bg-yellow';
            }
        } else if (type === 'text') {
            switch (color) {
                case 'yellow': return 'group-hover:text-yellow';
                case 'green': return 'group-hover:text-second';
                case 'purple': return 'group-hover:text-purple';
                default: return 'group-hover:text-yellow';
            }
        }
        return '';
    };

    return (
        <div>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12 p-6 sm:p-10 lg:p-20 lg:pt-16 lg:px-36'>
                {webAppData.ReliabilityWebAppData.map((reliable: any, index: number) => {
                     let img = getImage(reliable.image ?? "") ?? "";
                    return (
                        <motion.div
                            key={index}
                            className='flex flex-col items-center justify-center rounded-xl p-4 sm:p-6 lg:p-8 group'
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.2 }}
                            custom={index}
                            variants={stepAnimation}
                        >
                            <motion.div
                                className={`w-[50px] h-[50px] sm:w-[55px] sm:h-[55px] lg:w-[60px] lg:h-[60px] p-3 sm:p-4 ${getColorClass('bg', reliable.color)} bg-blackDarkThemePrimary rounded-xl flex items-center justify-center mb-3 sm:mb-4`}
                                whileHover={{ scale: 1.1 }}
                                transition={{ type: "spring", stiffness: 300 }}
                            >
                                {/* <img src={reliable.image} className='w-[100%] h-[100%]' /> */}
                                <DynamicSVG color='#fff' size='w-full h-full'>{img}</DynamicSVG>
                            </motion.div>
                            <div className={`text-lg sm:text-xl text-center font-semibold text-white ${getColorClass('text', reliable.color)}`}>{reliable.title}</div>
                            <div className='text-white text-center text-sm sm:text-md px-2 sm:px-4'>{reliable.subtitle}</div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default ReliabilityWebAppSteps
